// extracted by mini-css-extract-plugin
export default {"label":"reviewSpotInstructions_label__tsnmB","labelCol":"reviewSpotInstructions_labelCol__5E-8z"};